import type { FieldError, UseFormRegister } from 'react-hook-form'
import '../../style.scss'
import { ErrorIcon } from 'src/components/Icons/ErrorIcon'

interface Props {
  name: keyof {
    name?: string
    email?: string
    lastname?: string
    document?: string
    cpf?: string
    phone?: string
    number?: string
    complement?: string
    receiverName?: string
    street?: string
    city?: string
    state?: string
    neighborhood?: string
  }
  label?: string
  className?: string
  classNameError?: string
  classContainer?: string
  labelClassname?: string
  mask?: string
  errors: FieldError | undefined
  register?: UseFormRegister<{
    name?: string
    email?: string
    lastname?: string
    document?: string
    cpf?: string
    phone?: string
    number?: string
    complement?: string
    receiverName?: string
    street?: string
    city?: string
    state?: string
    neighborhood?: string
    reference?: string
  }>
  isValid?: boolean
  wrapperClassName?: string
  required?: boolean
}

type InputProps = JSX.IntrinsicElements['input'] & Props

export function PostalInput({
  name,
  label,
  className,
  classNameError,
  classContainer,
  register,
  errors,
  labelClassname,
  isValid,
  wrapperClassName,
  children,
  required,
  ...rest
}: InputProps) {
  const defaultLabelClassname = labelClassname ?? 'text-[#333] pb-2'
  const id = rest?.id ?? `input-${name}`

  return (
    <div className={`flex flex-col sm:w-1/2 w-full ${classContainer}`}>
      {label && (
        <label htmlFor={id} className={defaultLabelClassname}>
          {label}
          {required && <span className="text-[#D62828]"> *</span>}
          {required === false && (
            <span className="text-[#6B6B6B]"> (opcional)</span>
          )}
        </label>
      )}
      <div className={`input-wrapper ${wrapperClassName}`}>
        <input
          id={id}
          className={` border ${className} ${errors ? classNameError : ''} ${
            isValid ? 'border-success' : ''
          }`}
          {...(register ? register(name) : {})}
          name={name}
          aria-invalid={!!errors}
          {...rest}
        />
        {children}
      </div>
      {errors && (
        <div className="flex items-center mt-2 py-1 gap-1">
          <ErrorIcon width={16} height={16} color="#E3262F" />
          <span className="inline text-danger text-xs">{errors.message}</span>
        </div>
      )}
    </div>
  )
}
